/**
/* splash-top
 * ========================================================================== */

$(function() {
	if (window.matchMedia("(max-width: 619px)").matches) {
	// スマホ
	$('#splash-top .scene1').velocity(
		'fadeIn',
		{
			delay:1000,
			duration: 1000,
			complete: function(){
				$('#splash-top .scene1').velocity(
					'fadeOut',
					{
						delay:500,
						duration: 1000,
					}
				)
				$('#splash-top .scene2').velocity(
					'fadeIn',
					{
						delay:500,
						duration: 1000,
						complete: function(){
							$('#splash-top .scene2 img').addClass('active');
							$('#splash-top .scene2').velocity(
								'fadeOut',
								{
									delay:1000,
									duration: 1000,
								}
							)
							$('#splash-top .scene3').velocity(
								'fadeIn',
								{
									delay:1000,
									duration: 1000,
									complete: function(){
										$('#splash-top .scene3').velocity(
											'fadeOut',
											{
												delay:1000,
												duration: 1000,
											}
										)
										$('#splash-top .scene4').velocity(
											'fadeIn',
											{
												delay:1000,
												duration: 1000,
												complete: function(){
													$('#splash-top .scene4 img').addClass('active');
													$('#splash-top .scene4').velocity(
														'fadeOut',
														{
															delay:6000,
															duration: 1000,
														}
													)
													$('#splash-top .scene5').velocity(
														'fadeIn',
														{
															delay:6000,
															duration: 1000,
															complete: function(){
																$('#splash-top .scene5').velocity(
																	'fadeOut',
																	{
																		delay:1000,
																		duration: 1000,
																	}
																)
																$('#splash-top .scene6').velocity(
																	'fadeIn',
																	{
																		delay:1000,
																		duration: 1000,
																		complete: function(){
																			// setTimeout(() => {
																			// 	$('#mv').addClass('active');
																			// 	mainvisual();
																			// }, "1000")
																			
																			// $('#splash-top').velocity(
																			// 	'fadeOut',
																			// 	{
																			// 		delay:500,
																			// 		duration: 500,
																			// 	}
																			// )
																			$('#skip-btn').velocity(
																					'fadeOut',
																					{
																						delay:1000,
																					}
																			)
																		}
																	}
																)
															}
														}
													)
												}
											}
										)
									}
								}
							)
						}
					}
				)
			}
		}
	);
	}else{
	// PC
	$('#splash-top .scene1').velocity(
		'fadeIn',
		{
			delay:1000,
			duration: 1000,
			complete: function(){
				$('#splash-top .scene1').velocity(
					'fadeOut',
					{
						delay:500,
						duration: 1000,
					}
				)
				$('#splash-top .scene2').velocity(
					'fadeIn',
					{
						delay:500,
						duration: 1000,
						complete: function(){
							$('#splash-top .scene2 img').addClass('active');
							$('#splash-top .scene2').velocity(
								'fadeOut',
								{
									delay:6000,
									duration: 1000,
								}
							)
							$('#splash-top .scene3').velocity(
								'fadeIn',
								{
									delay:6000,
									duration: 1000,
									complete: function(){
										$('#splash-top .scene3').velocity(
											'fadeOut',
											{
												delay:500,
												duration: 1000,
											}
										)
										$('#splash-top .scene4').velocity(
											'fadeIn',
											{
												delay:500,
												duration: 1000,
												complete: function(){
													$('#splash-top .scene4 img').addClass('active');
													$('#splash-top .scene4').velocity(
														'fadeOut',
														{
															delay:6000,
															duration: 1000,
														}
													)
													$('#splash-top .scene5').velocity(
														'fadeIn',
														{
															delay:6000,
															duration: 1000,
															complete: function(){
																$('#splash-top .scene5').velocity(
																	'fadeOut',
																	{
																		delay:1000,
																		duration: 1000,
																	}
																)
																$('#splash-top .scene6').velocity(
																	'fadeIn',
																	{
																		delay:1000,
																		duration: 1000,
																		complete: function(){
																			// setTimeout(() => {
																			// 	$('#mv').addClass('active');
																			// 	mainvisual();
																			// }, "1000")
																			
																			// $('#splash-top').velocity(
																			// 	'fadeOut',
																			// 	{
																			// 		delay:500,
																			// 		duration: 500,
																			// 	}
																			// )
																			$('#skip-btn').velocity(
																					'fadeOut',
																					{
																						delay:1000,
																					}
																			)
																		}
																	}
																)
															}
														}
													)
												}
											}
										)
									}
								}
							)
						}
					}
				)
			}
		}
	);
	}
  

  //スキップボタン押下時
  $('#skip-btn').on('click touchend', function() {
      $('#splash ul').velocity(
          'fadeOut',
          {
              duration: 100,
              complete: function(){
                  $('#splash').velocity(
                      'fadeOut',
                      {
                          delay:100,
                          duration: 1000,
                          complete: function(){
                              $('.mainvisualText').velocity(
                                  'fadeIn',
                                  {
                                      duration: 3000,
                                  }
                              )
                          }
                      }
                  )
              }
          }
      )
      $('#skip-btn').velocity(
          'fadeOut',
          {
              duration: 100,
          }
      )
      // $('*').velocity('stop');
      // $('html,body').scrollTop(0);
      $('.top').removeClass('noscroll');
  });

});


/**
/* slick-mv
 * ========================================================================== */
function mainvisual() {
	$(function(){
		$('.slick-mv').slick({
			autoplay: true,
			autoplaySpeed:9500,
			speed :500,
			dots: false,
			fade:true,
			arrows:false,
			pauseOnHover: false,
			pauseOnFocus: false,
			responsive: [
				{
					breakpoint: 1024, // 399px以下のサイズに適用
					settings: {
					},
				},
				{
					breakpoint: 768, // 399px以下のサイズに適用
					settings: {
						autoplaySpeed:9500,
						speed :500,
					},
				},
			],
		});
	});
}


// イメージマップ
function changeMapImage(imgPath) {
    document.getElementById('map').src = imgPath;
}
function changeMapImage2(imgPath) {
    document.getElementById('map2').src = imgPath;
}
function changeMapImage3(imgPath) {
    document.getElementById('map3').src = imgPath;
}
$(document).ready(function (e) {
    imageMapResize();
});
$(function(){
	if (window.matchMedia('(max-width: 619px)').matches) {
        $('#map').attr('src', './img/top/slide-obi-sp.png');
        $('#map2').attr('src', './img/top/slide-obi02-sp.png');
        $('#map3').attr('src', './img/top/slide-obi03-sp.png');
	}
})




/**
/* クロス背景
 * ========================================================================== */
window.addEventListener("DOMContentLoaded", () => {
    const custom_anime01 = gsap.timeline({
      scrollTrigger: {
        trigger: ".js-bg-toriger1",
        start: "top center",
        // scrub: !0,
        // pin: !1,
      }
    });
    custom_anime01.to('.js-bg1', {
      keyframes: [{
        width: '150%'
      }]
    }, "<");
    const custom_anime02 = gsap.timeline({
      scrollTrigger: {
        trigger: ".js-bg-toriger2",
        start: "top center",
        // scrub: !0,
        // pin: !1,
      }
    });
    custom_anime02.to('.js-bg2', {
      keyframes: [{
        width: '150%'
      }]
    }, "<");
    const custom_anime03 = gsap.timeline({
      scrollTrigger: {
        trigger: ".js-bg-toriger3",
        start: "top center",
        // scrub: !0,
        // pin: !1,
      }
    });
    custom_anime03.to('.js-bg3', {
      keyframes: [{
        width: '150%'
      }]
    }, "<");
});